import {
    modelServices
} from '@/app/shared/services/client-agent-service.js';
import {
    httpClient
} from '@/app/shared/services/http-client/http-client.js';

export class PatientDetailsService {

    constructor() {
        this.AppointmentDetailsOData = modelServices.baseUrl + modelServices.getPharmacyServiceName("AppointmentDetailsOData").URL;
    }
    FilterPatientDetails(StartDateTime, EndDateTime, VisitClassificationID, filter, callback) {

        // var url = this.AppointmentDetailsOData; 
        let url = "http://localhost:2200/OPD.Services/odata/AppointmentDetailsOData?";
        let urlParameters = `${url}StartDateTime=${StartDateTime}&EndDateTime=${EndDateTime}&VisitClassificationID=${VisitClassificationID}&${filter}`
        httpClient.get(urlParameters).then(callback);
        
    }

}
const PatientDetailsServiceConst = new PatientDetailsService();

export {
    PatientDetailsServiceConst
};